import React, { useEffect, useState } from 'react';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useTranslation } from 'react-i18next';
import useDraftEditor from '../../../../hooks/useDraftEditor';
import { COURSE_DETAILS_BODY_CANCELLATIONS_LABEL, COURSE_DETAILS_BODY_INFO_LABEL, COURSE_DETAILS_BODY_EMPTY_COURSE_DESCRIPTION, COURSE_DETAILS_BODY_LECTURES_LABEL, COURSE_DETAILS_BODY_PARTICIPANTS_LABEL, COURSE_DETAILS_BODY_RESERVES_LABEL, COURSE_DETAILS_DESCRIPTION_LABEL } from '../../../../i18n/keyConstants';
import CourseBookings from './course-bookings';
import CourseLectures from './course-lectures';
import GeneralCourseInformation from './general-course-information';

const Accordion = ({ label, children, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      style={{
        borderBottom: "1px solid lightgrey",
        padding: open ? "16px 0px 0px 0px" : "16px 0px 16px 0px"
      }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer"
        }}
        onClick={() => setOpen((prev) => !prev)}
      >
        <h4 style={{ margin: 0 }}>{label}</h4>
        <div style={{ display: "flex", marginRight: "10px" }}>
          {open ? '⌃' : '⌄'}
        </div>
      </div>

      {open && (
        <div style={{ marginTop: "16px" }}>
          {children}
        </div>
      )}
    </div>
  )
}

const LeftPanel = ({ course }) => {
  const {
    editorState,
    setEditorState,
    jsonStringToEditorState
  } = useDraftEditor();

  const { t } = useTranslation('courseDetailsBody');

  useEffect(() => {
    setEditorState(jsonStringToEditorState(course.description));
  }, [course])

  return (
    <div className='details-left-panel'>
      <div className='editor-left-panel' style={{ position: "sticky", top: 83.75 }}>
        <Accordion label={t(COURSE_DETAILS_DESCRIPTION_LABEL)} defaultOpen>
          <Editor className='col-6 text-center'
            editorState={editorState}
            readOnly={true}
            toolbarHidden={true}
            placeholder={t(COURSE_DETAILS_BODY_EMPTY_COURSE_DESCRIPTION)}
            wrapperClassName="wrapper-class-read-only"
            editorClassName="editor-class editor-readonly"
            toolbarClassName="toolbar-class"
          />
        </Accordion>
      </div>
    </div>
  );
}

const RightPanel = ({ course, courseUser, cancelledBookings }) => {
  let reserveBookings = null;
  if (course.bookings !== null) {
      reserveBookings = course.bookings.filter(booking => booking.status === 1);
  }

  const { t } = useTranslation('courseDetailsBody');

  return (
    <div className="container details-right-panel">
      <div style={{ position: "sticky", top: 83.75 }}>
        <Accordion label={t(COURSE_DETAILS_BODY_INFO_LABEL)} defaultOpen>
          <GeneralCourseInformation course={course} courseUser={courseUser} />
        </Accordion>

        <Accordion label={t(COURSE_DETAILS_BODY_LECTURES_LABEL)}>
          <div className="d-flex p-1">
            <CourseLectures course={course} />
          </div>
        </Accordion>

        {(courseUser.editPermission || courseUser.teacherPermission) && (
        <div className='row justify-content-between flex-wrap'>

          <div className="col-sm-12 col-md-6 col-lg-4 accordion-participants" >
            <Accordion label={`${t(COURSE_DETAILS_BODY_PARTICIPANTS_LABEL)} (${course.bookings.filter(booking => booking.status !== 1).length})`}>
              <div className="p-1">
                  <CourseBookings 
                  bookings={course.bookings.filter(booking => booking.status !== 1)} 
                  bookingType={t(COURSE_DETAILS_BODY_PARTICIPANTS_LABEL).toLowerCase()}
                  />
              </div>
            </Accordion>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-4  accordion-reserves">
            <Accordion label={`${t(COURSE_DETAILS_BODY_RESERVES_LABEL)}  (${reserveBookings.length})`}>
              <div className="p-1">
                <CourseBookings 
                bookings={reserveBookings} 
                bookingType={t(COURSE_DETAILS_BODY_RESERVES_LABEL).toLowerCase()}
                />
              </div>
            </Accordion>
          </div>

          <div className="col-12 col-lg-4 accordion-cancelled">
            <Accordion label={`${t(COURSE_DETAILS_BODY_CANCELLATIONS_LABEL)} (${cancelledBookings.length})`}>
            <div className="p-1">
                  <CourseBookings 
                    bookings={cancelledBookings}
                    bookingType={t(COURSE_DETAILS_BODY_CANCELLATIONS_LABEL).toLowerCase()}
                    />
                  </div>
            </Accordion>
          </div>

        </div>
        )}
      </div>
    </div>
  );
}

export default function CourseDetailsBody({ course, courseUser, cancelledBookings }) {
  return (
    <div className='course-details-body'>
      <LeftPanel course={course} />
      {/* <LeftPanel className="col-xs-12" course={course} /> */}
      <RightPanel course={course} courseUser={courseUser} cancelledBookings={cancelledBookings}/>
      {/* <RightPanel className="col-xs-12" course={course} courseUser={courseUser} cancelledBookings={cancelledBookings}/> */}
    </div>
  )
}
